import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRecentOrders } from "../../actions/orders";
import { getAggregatedProducts, getProducts } from "../../actions/products";
import MainComponent from "../../components/main";
import Page from "../../components/vapor/page";

interface MainViewProps {
    showNotification?: any;
    setShowNotification: (val: any) => void;
}

const MainView = (props: MainViewProps) => {
    const [expanded, setExpanded] = useState(false);
    const [step, setStep] = useState(1);
    const parent = useSelector((state: RootState) => state.parent);
    // FIXME: (low-priority) issue here, loading package cause re-render of modals (lista atti)
    const isLoadingPackage = useSelector(
        (state: RootState) => state.userPackage.isLoadingPackage,
    );
    const packages = useSelector(
        (state: RootState) => state.userPackage.packages,
    );

    const dispatch: any = useDispatch();

    const backAndClear = () => {
        setStep(1);
    };

    useEffect(() => {
        if (!isLoadingPackage && packages) {
            dispatch(getProducts());
            dispatch(getAggregatedProducts());

            if (packages.length > 0) {
                dispatch(getRecentOrders());
            }
        }
    }, [dispatch, isLoadingPackage, packages]);

    return (
        <Page
            title="BUSINESS INFORMATION"
            subtitle={`${parent.item.description} / c.f. ${parent.item.taxId}`}
            backFunction={
                step > 1
                    ? () => {
                          backAndClear();
                      }
                    : undefined
            }
            backText={step > 1 ? "Torna indietro" : ""}
            showBoughtDocuments
            expanded={expanded}
            setExpanded={(val) => setExpanded(val)}
            withPadding
        >
            <MainComponent
                showNotification={props.showNotification}
                setShowNotification={props.setShowNotification}
                expanded={expanded}
                step={step}
                setStep={setStep}
            />
        </Page>
    );
};

export default MainView;
